module.exports = __webpack_public_path__ + "img/41-60.6fcacb71.svg";